import Vue from 'vue'

Vue.directive('focus', {
  inserted: function (el) {
    // 获取焦点
    el.focus()
    console.info('inserted' + el)
  }
})

Vue.directive('drag', {
  inserted: function (el) {
    let oDiv = el
    oDiv.ontouchstart = function (ev) {
      let disX = ev.touches[0].clientX - oDiv.offsetLeft
      let disY = ev.touches[0].clientY - oDiv.offsetTop
      document.ontouchmove = function (ev) {
        let l = ev.touches[0].clientX - disX
        let t = ev.touches[0].clientY - disY
        if (l < 0 || t < 0 || l > document.documentElement.clientWidth - (2 * disX) || t > document.documentElement.clientHeight - (2 * disY)) {
          return
        }
        oDiv.style.left = l + 'px'
        oDiv.style.top = t + 'px'
      }
      document.ontouchend = function () {
        document.ontouchmove = null
        document.ontouchend = null
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/directives.js